import React from 'react';

import type { ColProps } from '@sravni/react-design-system/lib/Grid';
import { Col, Row } from '@sravni/react-design-system/lib/Grid';
import { Space } from '@sravni/react-design-system/lib/Space';
import {
  AgreementCheckbox,
  EmailInput,
  Form,
  GetOTPButton,
  NameInput,
  PhoneInput,
  ServerErrorMessage,
  SubmitButton,
  useIsOTPSended,
} from '@sravni/react-silent-authentication-form';
import { useStyles } from '@sravni/react-utils';

import { OTPInput } from './components/OTPInput';
import { AuthInlineFormProps } from './interfaces';
import styles from './styles.module.scss';

export const AuthInlineForm = React.forwardRef<HTMLFormElement, AuthInlineFormProps>((props, ref) => {
  const { children, onGetOTPLinkClick, onGetOTPButtonClick, onChangeAgreementValue, ...rest } = props;
  const cx = useStyles(styles);
  const [isOTPSended] = useIsOTPSended();

  const DEFAULT_SPAN: ColProps['span'] = { mobile: 12, tablet: isOTPSended ? 4 : 3, desktop: isOTPSended ? 4 : 3 };

  return (
    <Form enableAutoSubmit={false} {...rest} ref={ref}>
      <Row gutter={[16, 16]}>
        <Col span={DEFAULT_SPAN}>
          <NameInput />
        </Col>
        <Col span={DEFAULT_SPAN}>
          <EmailInput />
        </Col>
        <Col span={DEFAULT_SPAN}>
          <PhoneInput />
        </Col>
        {isOTPSended ? (
          <Col span={{ mobile: 12, tablet: 4, desktop: 4 }}>
            <Space size={[8, 0]} justify="space-between">
              <OTPInput onGetOTPLinkClick={onGetOTPLinkClick} />
              <SubmitButton square size={60} className={cx('submitButton')} />
            </Space>
          </Col>
        ) : (
          <Col span={DEFAULT_SPAN}>
            <GetOTPButton onClick={onGetOTPButtonClick} />
          </Col>
        )}
        <Col span={{ mobile: 12 }}>
          <AgreementCheckbox onChange={onChangeAgreementValue}>
            {'При входе вы даёте согласие на '}
            <a href="https://www.sravni.ru/promo/review-rules/" target={'_blank'} rel={'noreferrer'}>
              публикацию отзыва
            </a>
            {', {opdLink|обработку персональных данных} и {advertisingLink|получение рекламы}'}
          </AgreementCheckbox>
        </Col>
        <Col span={{ mobile: 12 }}>
          <ServerErrorMessage />
        </Col>
      </Row>
      {children}
    </Form>
  );
});
